import {createSlice} from '@reduxjs/toolkit';
import {baseSetValue} from "../../utils";
import {FeaturedContent, MediaItem} from "../../api/types";

export interface HomeSliceState {
    isLoading: boolean;
    featuredContent: FeaturedContent[];
    recommendations: MediaItem[];
}

const initialState: HomeSliceState = {
    isLoading: false,
    featuredContent: [],
    recommendations: [],
};
export const reducers = createSlice({
    name: 'home',
    initialState,
    reducers: {
        setValue: baseSetValue<HomeSliceState>()
    },
});

export const {setValue} = reducers.actions;
export default reducers.reducer;
